import React from "react";

const Spinner = () => {
  return <div className="spinner"></div>;
};

export default Spinner;
